import React from 'react';

import { TestMessageTemplateInput } from './send-test-message.types';
import {
  SendTestMessageControllerReturns,
  useSendTestMessageController,
} from './use-send-test-message-controller.hook';

type SendTestMessageControllerProps = {
  children: SendTestMessageControllerRenderCallback;
} & TestMessageTemplateInput;

export type SendTestMessageControllerRenderCallback = (
  props: SendTestMessageControllerReturns,
) => React.ReactNode;

export const SendTestMessageController = (props: SendTestMessageControllerProps) => {
  const { children, smsBody, pushNotificationTemplate } = props;
  const controller = useSendTestMessageController({ smsBody, pushNotificationTemplate });
  return children(controller);
};
